import AdminWidget from '../AdminWidget.js';
import Ajax from '../../../../../common/js/Ajax.js';
import ButtonUtils from '../../../../../common/js/ButtonUtils.js';
import Form from '../../../../../common/js/form/Form.js';
import MessageUtils from '../../../../../common/js/MessageUtils.js';
import UrlParser from '../../../../../common/js/UrlParser.js';

import TEMPLATE from './OrderWidget.hbs';

export default class OrderWidget extends AdminWidget {

	constructor($widget) {
		super($widget);
		this.orderId = UrlParser.getParams()['id'];
		if (!this.orderId) {
			MessageUtils.error($widget, 'Missing order ID');
			return;
		}

		this.spinner();
		Ajax.rpc('/order', {id: this.orderId}, order => {
			this.render(order);
			this.setPageHeadline('Order ' + order.orderNumber);
		}, error => {
			MessageUtils.error($widget, 'Failed to load order', error);
		});
	}

	increaseRequests($button) {
		var $activation = $button.closest('.js_activation');
		var activationId = $activation.attr('data-id');
		var $maximumRequests = $activation.find('.js_maximum-requests');
		var maximumRequests = parseInt($maximumRequests.text(), 10) + 10;

		ButtonUtils.setState($button, 'active');
		Ajax.rpc('/updateActivation', {
			activationId: activationId,
			maximumRequests: maximumRequests
		}, () => {
			ButtonUtils.setState($button, 'success');
			$maximumRequests.text(maximumRequests);
		}, error => {
			ButtonUtils.setState($button, 'none');
			MessageUtils.error($widget.find('.js_activation-message'), 'Failed to update activation', error);
		});
	}

	render(order) {
		this.$widget.html(TEMPLATE(order));

		Form.onSubmit(this.$widget.find('.js_order-form'), action => {
			this.saveOrder(action);
		})

		Form.onSubmit(this.$widget.find('.js_key-form'), action => {
			this.saveKey(action);
		})

		this.$widget.find('.js_increase-requests').click(event => {
			this.increaseRequests($(event.currentTarget));
		})
	}

	saveOrder(action) {
		var comment = action.findField('comment').val();
		Ajax.rpc('/updateOrder', {
			orderId: this.orderId,
			paymentState: action.findField('paymentState').filter(':checked').val(),
			shippingState: action.findField('shippingState').filter(':checked').val(),
			salutation: action.findField('salutation').val(),
			firstName: action.findField('firstName').val(),
			lastName: action.findField('lastName').val(),
			streetName: action.findField('streetName').val(),
			streetNumber: action.findField('streetNumber').val(),
			zip: action.findField('zip').val(),
			city: action.findField('city').val(),
			country: action.findField('country').val(),
			lang: action.findField('lang').val(),
			email: action.findField('email').val(),
			comment: comment !== '' ? comment : '%'
		}, order => {
			this.render(order);
			// Can't use action, as the $form is from the previous rendering
			ButtonUtils.setState(this.$widget.find('.js_order-form [type="submit"]'), 'success');
		}, error => {
			action.error('Failed to update order', error);
		});
	}

	saveKey(action) {
		Ajax.rpc('/updateKey', {
			keyId: action.$form.attr('data-keyid'),
			enabled: !!action.findField('enabled').is(':checked'),
			licenses: action.findField('licenses').val(),
			licensee: action.findField('licensee').val()
		}, () => {
			action.ok();
		}, error => {
			action.error('Failed to update key', error);
		});
	}

}
